import { Component, ViewChild } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CommonModule, Location } from '@angular/common';
import { OrdersService } from '../../core/services/orders/orders.service';
import { TranslateModule } from '@ngx-translate/core';
import { AlertService } from '../../core/services/alert/alert.service';
import { Tags } from '../../core/interfaces/tags';
import { FormAddTagsComponent } from './form-add-tags/form-add-tags.component';
import { TagsService } from '../../core/services/tags/tags.service';
import { RouterLink } from '@angular/router';
@Component({
  selector: 'app-tags',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    TranslateModule,
    FormAddTagsComponent,
    RouterLink
  ],
  templateUrl: './tags.component.html',
  styleUrl: './tags.component.css',
})
export class TagsComponent {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  showForm = false;
  dataSource = new MatTableDataSource<any>();
  tags_reference?: any;
  tagsData?: any;

  pageNumber: number = 1;
  pageSize: number = 25;

  displayedColumns: string[] = [
    'name',
    'entity',
    'hex',
    'rowActions',
  ];

  constructor(
    private tagsService: TagsService,
    private alertService: AlertService,
    private location: Location
  ) { }

  ngAfterViewInit() {
    this.fetchData();
  }

  fetchData(): void {
    this.alertService.loading();
    this.tagsService.getTags(this.pageNumber, this.pageSize).subscribe({
      next: (data) => {
        this.dataSource.data = data.data;
        if (data.meta) {
          this.paginator.length = data.meta.total;
          this.paginator.pageSize = this.pageSize;
          this.paginator.pageIndex = this.pageNumber - 1;
        }
        this.dataSource.sort = this.sort;
        this.alertService.close();
      },
      error: (error) => console.error('There was an error!', error),
    });
  }

  onPageChange(event: any): void {
    this.pageNumber = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.fetchData();
  }

  toggleForm() {
    this.showForm = !this.showForm;
  }

  getBadgeColor(status: string) {
    const statusMap: { [key: string]: string } = {
      draft: 'text-bg-secondary',
      received: 'text-bg-info',
      pending: 'text-bg-danger',
      approved: 'text-bg-success',
      completed: 'text-bg-success',
      uncompleted: 'text-bg-warning',
      in_progress: 'text-bg-warning',
    };

    return statusMap[status] || 'text-bg-primary';
  }

  cerrarFormulario() {

    this.tagsData = null;
    this.showForm = false;

  }

  refrescar() {
    this.showForm = false;
    this.fetchData();
  }

  getTags(reference: string): void {
    
    this.tags_reference = reference;
    this.alertService.loading('swal_messages.please_wait');
    this.tagsService.getTag(reference).subscribe({
      next: (data) => {
        this.alertService.close();
        this.tagsData = data.data;
        this.showForm = true;
        // Si el formulario hijo tiene un color picker, actualízalo
        setTimeout(() => {
          const colorInput = document.querySelector<HTMLInputElement>(
            'app-form-add-tags input[type="color"]'
          );
          if (colorInput && data.data && data.data.hex) {
            colorInput.value = data.data.hex;
          }
        }, 0);
      },
      error: (error) => {
        this.alertService.error('swal_messages.tags.not_found');
      },
    });
  }

  deleteTags(reference: string): void {
    this.alertService
      .confirmation2(
        'swal_messages.tags.delete_tags',
        'swal_messages.tags.delete_tags_message',
        'swal_messages.confirm',
        'swal_messages.back'
      )
      .then((result) => {
        if (result.isConfirmed) {
          this.tags_reference = reference;
          this.alertService.loading('swal_messages.please_wait');
          this.tagsService.deleteTag(reference).subscribe({
            next: (data) => {
              this.fetchData();
            },
            error: (error) => {
              this.alertService.error(error.error.tags[0].msg);
            },
          });
        } else {
        }
      });
  }
}
